export default __webpack_public_path__ + "images/90e82adef18b72674afafd04f3d8aae9-experimental_small.webp";